import React from 'react';
interface SectionHeadingProps {
  eyebrow: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
  tone?: 'light' | 'dark';
}
export function SectionHeading({
  eyebrow,
  title,
  intro,
  tone = 'light'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <div className="mx-auto max-w-2xl text-center" data-id="element-198" data-mp="y6zq9mmdj730">
      <p className={`text-[11px] font-bold uppercase tracking-[0.22em] ${isDark ? 'text-gold-400' : 'text-gold-500'}`} data-id="element-199" data-mp="y8atnlbwqctl">
        {eyebrow}
      </p>
      <h2 className={`mt-3 font-display text-[27px] font-bold leading-[1.15] sm:text-4xl ${isDark ? 'text-white' : 'text-navy-950'}`} data-id="element-200" data-mp="5jcaqlzyn6n8">
        {title}
      </h2>
      {intro && <div className={`mt-4 space-y-3 text-[15px] leading-relaxed sm:text-base ${isDark ? 'text-white/70' : 'text-slate-600'}`} data-id="element-201" data-mp="ffozr6kk8wbn">
          {intro}
        </div>}
    </div>;
}